import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";

export class NavigationSeparator extends React.Component
{
    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        return (
            <div className="nav_separator"></div>
        );
    }
}